import BaseModal from 'basic-ui-lib/components/Modal/BaseModal';
import { SelectStore } from 'modules/dashboard/screens/Create/components';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface NewPlaylistModalProps {
  isOpen?: boolean;
  onClose?: () => void;
}

const NewPlaylistModal = ({ isOpen, onClose }: NewPlaylistModalProps) => {
  const navigate = useNavigate();

  const handleContinue = (storeId: string) => {
    navigate('/playlist/create', { state: { storeId } });
  };

  return (
    <BaseModal title='Create New Playlist' isOpen={isOpen} width={1000} onClose={onClose} hiddenFooter>
      <Container>
        <SelectStore onContinue={handleContinue} />
      </Container>
    </BaseModal>
  );
};

export default NewPlaylistModal;

const Container = styled.div`
  padding: 0 24px 24px;
`;